<section class="fb-filter flex flex-col justify-center items-center">
	<fb-filter-body class="w-full max-w-[1290px]" [data]="filterData"></fb-filter-body>
</section>
